import React, { useEffect, useState, useMemo } from 'react';

import { useMedia } from 'react-use';
import {
  getDateString,
  getSbStatusString,
  humanize,
  isExpired,
  ProjectModel,
  SbCurrentUser,
  SbStatusMaster,
  SubmissionBoardModel,
  SubmissionKitTagsModel,
} from '../component/SbModel';

import sbProfilesMediaService from '../../services/SbProfilesMediaService';
import { showToast } from '../../shared/Toast';
import { SbMediaRequestModel, SbProfilesMediaModel, SubmissionKitDocumentModel } from '../../submission_kits/components/KitModels';

import SbMediaRequestPerf from './SbMediaRequestPerf';
import SbProfileListItemPerf from './SbProfileListItemPerf';
import CustomTabs from '../component/CustomTabs';
import { MessageCircleWarning } from 'lucide-react';
import { useIsMobile } from '../component/useIsMobile';

interface SbDetailsListItemPerfProps {
  fromScreen: string;
  indexRow: number;
  currentUser: SbCurrentUser;
  currentUserMedia?: any;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  key_token?: string;
  otp_valid?: string;
  sb_recipient?: any;
  dialogCloseHandler?: (open: boolean) => void;
  refreshSubmissionBoard?: () => void;
  editSb: (index: number) => void;
  onUnfulfilledRequestsCountChange?: (submissionBoardId: number, count: number) => void;
}

// For SB details for SB creator
export default function SbDetailsListItemPerf({
  fromScreen,
  currentUser,
  // currentUserMedia, 
  project,
  submissionBoardModel,
  // key_token,
  // otp_valid,
  // sb_recipient,
  dialogCloseHandler,
  refreshSubmissionBoard,
  indexRow,
  editSb,
  onUnfulfilledRequestsCountChange,
}: SbDetailsListItemPerfProps) {
  const isMobile = useIsMobile();
  const [tabSelected, setTabSelected] = useState<number>(1);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [tabs, setTabs] = useState([]);

  const [submissionBoardInfo, setSubmissionBoardInfo] = useState(null);
  
  const [submissionKitTags, setSubmissionKitTags] = useState<SubmissionKitTagsModel[]>([]);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbLocked, setIsSbLocked] = useState(false);
  const [submissionKitDocuments, setSubmissionKitDocuments] = useState<
    SubmissionKitDocumentModel[]
  >([]);
  const [sbProfilesMedias, setSbProfilesMedias] = useState<SbProfilesMediaModel[]>([]);
  const [sbMediaRequests, setSbMediaRequests] = useState<SbMediaRequestModel[]>([]);
  const [combinekitDocuments, setCombinekitDocuments] = useState([]);

  const [sbMediaRequestFullfill, setSbMediaRequestFullfill] = useState<any[]>([]);
  const [actualMediaCount, setActualMediaCount] = useState(0);

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  //   const newRequestsCount = useMemo(() => {
  //   return sbMediaRequests.filter(request => {
  //     const daysAgo = Math.floor(
  //       (new Date().getTime() - new Date(request.updated_at).getTime()) / (1000 * 60 * 60 * 24)
  //     );
  //     return daysAgo <= 2;
  //   }).length;
  //  }, [sbMediaRequests]);
  const getUnfulfilledRequestsCount = useMemo(() => {
    if (sbMediaRequestFullfill.length === 0) {
      return sbMediaRequests.filter(request => !request.status).length;
    }

    const latestFulfillment = sbMediaRequestFullfill.reduce((latest, current) => {
      const latestTime = new Date(latest.created_at).getTime();
      const currentTime = new Date(current.created_at).getTime();
      return currentTime > latestTime ? current : latest;
    });

    const latestFulfillmentTime = new Date(latestFulfillment.created_at).getTime();
    return sbMediaRequests.filter(request => {
      const requestTime = new Date(request.updated_at).getTime();
      return !request.status && requestTime > latestFulfillmentTime;
    }).length;
  }, [sbMediaRequests, sbMediaRequestFullfill]);
  useEffect(() => {
    if (onUnfulfilledRequestsCountChange && submissionBoardModel?.id) {
      onUnfulfilledRequestsCountChange(submissionBoardModel.id, getUnfulfilledRequestsCount);
    }
  }, [getUnfulfilledRequestsCount, onUnfulfilledRequestsCountChange, submissionBoardModel?.id]);
  useEffect(() => {
    console.log('submissionBoardModel [] ', submissionBoardModel);
    if (
      submissionBoardModel.sb_status == SbStatusMaster.expired ||
      submissionBoardModel.sb_status == SbStatusMaster.locked ||
      isExpired(submissionBoardModel?.expire_at)
    ) {
      setIsSbLocked(true);
    } else {
      setIsSbLocked(false);
    }
    setSelectedSubmissionBoard(submissionBoardModel);
  }, [submissionBoardModel]);


  useEffect(() => {
    if (selectedSubmissionBoard != null) {
      console.log('selectedSubmissionBoard.profiles', selectedSubmissionBoard.profiles);
      fetchSbProfilesMedia();
      let _tabs = [];


      _tabs.push({ id: 1, name: isMobile ? "Submission Kit" : 'Your Submission Kit', show: true });
      _tabs.push({
        id: 2,
        name: (
          <div className="flex items-center gap-2">
            <span>{isMobile ? "Requests" : "Role and Requests"}</span>
            {getUnfulfilledRequestsCount > 0 && (
              <span className="flex items-center gap-2 border border-yellow-500 rounded-md px-2 py-1 text-xs font-semibold text-red-700">
                <MessageCircleWarning className="w-4 h-4" style={{ color: '#FF8400' }} />
                <span>{getUnfulfilledRequestsCount} Pending</span>
              </span>
            )}
          </div>
        ),
        show: true,
      });
      setTabs(_tabs);
    }

  }, [selectedSubmissionBoard, getUnfulfilledRequestsCount]);

  useEffect(() => {
    if (tabSelected === 2 && selectedSubmissionBoard?.id) {
      fetchSbProfilesMedia();
    }
  }, [tabSelected, selectedSubmissionBoard?.id]);

  const fetchSbProfilesMedia = async () => {
    try {
      setIsRefreshing(true);
      const resp = await sbProfilesMediaService.getBySubmissionBoard(
        project.uuid,
        selectedSubmissionBoard.id
      );
      if (resp) {  
        if ('submission_board' in resp) {
          setSubmissionBoardInfo(resp.submission_board);
        }
        if ('submission_kit_tags' in resp) {
          setSubmissionKitTags(resp.submission_kit_tags);
        }
        let _submissionkitDocuments = [];
          if ('submission_kit_documents' in resp) {
          for (let index = 0; index < resp.sb_profiles_medias.length; index++) {
            const element = resp.sb_profiles_medias[index];
            if (element.media_status == 'Remove') {
              const sbIndex = resp.submission_kit_documents.findIndex(
                (item) => item.kit_document.id == element.kit_document_id
              );
              if (sbIndex !== -1) {
                resp.submission_kit_documents.splice(sbIndex, 1);
              }
            }
          }
          _submissionkitDocuments = resp.submission_kit_documents;
          setSubmissionKitDocuments(resp.submission_kit_documents);
        }
        let _sbProfilesMedias = [];
        if ('sb_profiles_medias' in resp) {
          _sbProfilesMedias = resp.sb_profiles_medias;
          setSbProfilesMedias(resp.sb_profiles_medias);
        }

        if (_submissionkitDocuments != null) {
          let kitDocuments = [];
          if (_sbProfilesMedias && _sbProfilesMedias != null && _sbProfilesMedias.length > 0) {
            const tagVideos = _sbProfilesMedias;
            kitDocuments = [...kitDocuments, ...tagVideos];
          }
          if (_submissionkitDocuments && _submissionkitDocuments.length > 0) {
            // if tag and add is already in _sbprofile media and then ignore that SK
            _submissionkitDocuments = _submissionkitDocuments.filter((itemSkd) => {
              if (kitDocuments.findIndex((item) => item.tag == itemSkd.tag && item.media_status == 'Add') >= 0) {
                return false;
              }
              return true;
            })
            kitDocuments = [...kitDocuments, ..._submissionkitDocuments];
          }
          kitDocuments.map((item, index) => {
            if ('kit_document' in item) {
              item.kit_document_id = item.kit_document.id;
            }
          });

          setCombinekitDocuments(kitDocuments);
        }

        if ('sb_media_requests' in resp) {
          setSbMediaRequests(resp.sb_media_requests);
        }
        if ('sb_media_request_fullfill' in resp) {
          setSbMediaRequestFullfill(resp.sb_media_request_fullfill);
        }
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sb: fetchMediaKits Out');
      console.log('sb: isLoading false');
      setIsRefreshing(false);
      // setIsLoading(false);
    }
  };

  const addToSubmissionKit = async (kit_document: any, tag: string) => {

    let _sp_profiles_media = [...sbProfilesMedias];
    // if image is already added in SK or PM then ignore it. dont allow same image
    const elementPresentSk = submissionKitDocuments.findIndex(
      (item) => item.kit_document.id == kit_document.id
    );
    if (elementPresentSk >= 0) {
      // if present in SK and status is remove then delete that from _sp_profiles_media
      // if present in SK and status is add then return error

      // if not removed from PM then return false
      const elementPresent2: SbProfilesMediaModel = _sp_profiles_media.find(
        (item) => item.kit_document_id == kit_document.id
      );
      if (elementPresent2) {
        if (elementPresent2.media_status == 'Remove') {
          const resp = await sbProfilesMediaService.delete(project.uuid, elementPresent2);
          if (resp) {
            await fetchSbProfilesMedia();
          }
          return;
        } else {
          showToast('Image/video is already added.', 'danger');
          return false;
        }
      }
    }
    const elementPresent = _sp_profiles_media.findIndex(
      (item) => item.kit_document_id == kit_document.id && item.media_status == 'Add'
    );
    if (elementPresent >= 0) {
      showToast('Image/video is already added.', 'danger');
      return false;
    }
    const resp = await sbProfilesMediaService.create(
      project.uuid,
      selectedSubmissionBoard.id,
      kit_document.id,
      0,
      tag
    );
    if (resp && 'sp_profiles_media' in resp) {
      await fetchSbProfilesMedia();
    }
    return true;
  };

  const getSBCreatorName = () => {
    let owner_name = submissionBoardModel.owner_name;
    if (owner_name) {
      return owner_name;
    }
    let created_by = submissionBoardModel.created_by;
    if (submissionBoardInfo && submissionBoardInfo?.name) {
      return submissionBoardInfo.name;
    }
    if (created_by > 0) {
      if (submissionBoardModel?.coordinators && submissionBoardModel?.coordinators.length > 0) {
        const resp = submissionBoardModel?.coordinators.find((item) => item.user_id == created_by);
        if (resp) {
          return resp.name;
        }
      }
    }
    return '';
  };
  const getSBCreatorNameElement = () => {
    const created_by_name = getSBCreatorName();
    if (created_by_name != '') {
      return (
        <div className="font-normal text-base">
          <span className="font-bold text-base">{created_by_name}</span>{' '}
          {'has prepared talent submissions for:'}
        </div>
      );
    }
    return <div className="font-normal text-base">Talent submissions for:</div>;
  };

  const SubmisstionKitTab = () => {
    return (
      <>

        <SbProfileListItemPerf
          currentUser={currentUser}
          addToSubmissionKit={async function (kit_document: any, tag: string): Promise<boolean> {
            return await addToSubmissionKit(kit_document, tag);
          }}
          onMediaChange={() => fetchSbProfilesMedia()}
          onMediaCountChange={(count) => {
            setActualMediaCount(count);
          }}
          submissionKitTags={submissionKitTags}
          submissionkitDocuments={submissionKitDocuments}
          sbProfilesMedias={sbProfilesMedias}
          enableLike={false}
          profile_status={''}
          project={project}
          submissionBoardModel={submissionBoardModel}
        ></SbProfileListItemPerf>
      
      </>
    );
  }
  const RoleRequestTab = () => {
    return (
      <>
        {/* <div className="flex w-full flex-col  sm:flex-row gap-2-1 px-0 py-0 items-center justify-between border-b-1 border-gray-200 border-b"> */}
        <div className="flex w-full flex-col sm:flex-row justify-between mb-0 ">
          <div className="flex w-full items-center font-semibold text-2xl text-gray-900  ">
            Role and Requests
          </div>
          <div className="flex w-full items-center sm:justify-end font-normal text-sm text-gray-900 ">
            <div className="font-semibold ">{actualMediaCount} Media Assets</div>
            <div>&nbsp;submitted for this Role</div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-10 sm:px-5 py-10 border-t border-gray-300">
          {/* 🔹 User Guide Card (sidebar) */}
          <div className="w-full sm:w-1/4 flex-col flex shrink-0 pb-8 pl-8">
            <div className="flex flex-col gap-5 sm:flex-col  gap-1 justify-between items-center ">
              <div className="text-base font-semibold  text-left h-20 justify-start items-center flex w-full ">
                <span>Board Notes</span>
              </div>
              {/* coordinator, created, expired, status */}
              <div className="flex flex-col  w-full gap-5 py-7 pr-7 pl-5 bg-gray-100 border-blue-402 text-sm text-black-600 border rounded-lg">
                <div>
                  <div className="font-normal text-xs">Coordinator</div>
                  <div className="font-semibold text-base">
                    {getSBCreatorName()}
                  </div>
                </div>
                <div>
                  <div className="font-normal text-xs">Created at</div>
                  <div className="font-semibold text-base">
                    {getDateString(selectedSubmissionBoard?.created_at, 'PP')}
                  </div>
                </div>
                <div>
                  <div className="pt-2 font-normal text-xs">Expire at</div>
                  <div
                    className={
                      'font-semibold text-base' +
                      (isExpired(selectedSubmissionBoard?.expire_at) ? ' text-red-500 ' : '')
                    }
                  >
                    {getDateString(selectedSubmissionBoard?.expire_at, 'PP')}
                  </div>
                </div>

                <div>
                  <div className="pt-2 font-normal text-xs">Status</div>
                  <div className="font-semibold text-base">
                    {humanize(selectedSubmissionBoard.sb_status ?? '') === SbStatusMaster.pending_review
                      ? getSbStatusString(SbStatusMaster.pending_review)
                      : humanize(selectedSubmissionBoard.sb_status ?? '') === SbStatusMaster.open
                        ? getSbStatusString(SbStatusMaster.open)
                        : humanize(selectedSubmissionBoard.sb_status ?? '')}
                  </div>
                </div>
              </div>
              {/* coordinator, role, episode, project start */}
              <div className="flex flex-col w-full gap-5 py-7 pr-7 pl-5 bg-gray-100 border-blue-402 text-sm text-black-600 border rounded-lg">
                <div className='flex-1 inline items-center gap-1-1'><div className='font-semibold'>{getSBCreatorName()}</div> has prepared talent submissions for:
                </div>
                <div>
                  <div className="font-normal text-xs">Role</div>
                  <div className="font-semibold text-base">{submissionBoardModel.title}</div>
                </div>
                {((submissionBoardModel?.episode_name ?? '') != '' ||
                  (submissionBoardModel?.scene_name ?? '') != '') && (
                    <div>
                      <div className="pt-2 font-normal text-xs">Scene/Episode</div>
                      <div className="font-semibold text-base">
                        {submissionBoardModel?.episode_name
                          ? submissionBoardModel.episode_name + ' / '
                          : ''}
                        {submissionBoardModel?.scene_name ?? ''}
                      </div>
                    </div>
                  )}

                <div>
                  <div className="pt-2 font-normal text-xs">Project</div>
                  <div className="font-semibold text-base">{project.title}</div>
                </div>
              </div>
              {/* coordinator, role, episode, project end */}
            </div>
          </div>

          <div className="w-full sm:w-3/4 gap-5 flex flex-col">
            <div className="flex flex-col sm:flex-row sm:items-center  gap-2 h-20">
              <div className="text-base font-semibold">Requests
                {getUnfulfilledRequestsCount > 0 && (
                  <span className="ml-2 text-base font-normal tracking-wide">
                    <span>({getUnfulfilledRequestsCount} Pending)</span>
                  </span>
                )}
              </div>
            </div>
            <SbMediaRequestPerf requests={sbMediaRequests}
              fullfillments={sbMediaRequestFullfill}
              getSBCreatorName={getSBCreatorName} />
          </div>
        </div>
      </>
    );
  };


  return (
    <>
      <div className="scrollable-content overflow-visible justify-items-center">
        {selectedSubmissionBoard != null && (
          <div className="flex w-full flex-col px-2">
            {/* <SbDetailCard
              indexRow={indexRow}
              fromScreen={fromScreen}
              project={project}
              submissionBoardModel={selectedSubmissionBoard}
              refreshSubmissionBoard={() => {
                if (refreshSubmissionBoard) {
                  refreshSubmissionBoard();
                }
              }}
              editSb={function (index: number): void {}}
              isSbClosed={isSbLocked}
              sbCreatorName={getSBCreatorName()}
            ></SbDetailCard> */}
            <div className="mt-1 justify-items-center p-2 gap-8 flex flex-col">
              <div className="flex flex-col sm:flex-row border-b gap-1 justify-between items-center">
                <div className=" w-full flex flex-row">
                  <CustomTabs
                    tabSelected={tabSelected}
                    tabs={tabs}
                    tabSelectHandler={(id: number) => setTabSelected(id)}
                  />

                  {/* <button
                    onClick={() => {
                      setTabSelected(1);
                    }}
                    className={
                      'py-5 px-4 ' +
                      (tabSelected == 1 ? 'border-b-2 border-blue-500 text-blue-500' : '')
                    }
                  >
                    Your Submission Kit
                  </button>
                  <button
                    onClick={() => {
                      setTabSelected(2);
                    }}
                    className={
                      'py-5 px-4 ' +
                      (tabSelected == 2 ? 'border-b-2 border-blue-500 text-blue-500' : '')
                    }
                  >
                    Role and Requests
                  </button> */}
                </div>
                {/* Right View Toggle Buttons */}
                <div className="flex flex-1 items-center gap-2-1 pr-5 justify-end">
                  <div className="flex items-center gap-2-1"></div>
                </div>
                {/* View Toggle Buttons end */}
              </div>
              {tabSelected == 1 && SubmisstionKitTab()}
              {tabSelected == 2 && RoleRequestTab()}
            </div>
            {/* <div className="scrollable-content overflow-visible justify-items-center ">
              <div className="flex w-full flex-col p-0 sm:p-2 ">
                <div className="flex gap-6 ">
                  <div className="w-full sm:w-1/4 flex-col flex shrink-0">
                    <div className="flex flex-col sm:flex-row border-b  gap-2 justify-between items-center h-20">
                      <div className="text-base font-semibold  text-left">
                        <span>Board Notes</span>
                      </div>
                    </div>
                    <div className="p-4 flex flex-col bg-heart-of-ice border-l-8 border-blue-400 text-sm text-black-600 border rounded-lg">
                      {getSBCreatorNameElement()}
                      <div className="pt-2 font-normal text-xs">Role</div>
                      <div className="font-semibold text-base">{submissionBoardModel.title}</div>
                      <div className="pt-2 font-normal text-xs">Project</div>
                      <div className="font-semibold text-base">{project.title}</div>
                    </div>
                    <div className="flex gap-6 flex-col gap-2 justify-between items-left">
                      <div className="text-base font-semibold py-4">
                        <SbMediaRequestPerf requests={sbMediaRequests} />
                      </div>
                    </div>
                  </div>

                  <div className="w-full sm:w-3/4 gap-7 flex flex-col">
                    <div className="flex flex-col sm:flex-row border-b gap-2 justify-center items-center h-20">
                      <div className="text-base font-semibold text-center">
                        Customize and Submit Your Profile
                      </div>
                    </div>
                    <div
                      className={(is400_639Screen ? 'px-0' : 'p-0') + ' flex gap-5'}
                      id="list_active"
                    >
                      {submissionKitDocuments && submissionKitDocuments.length > 0 && (
                        <SbProfileListItemPerf
                          addToSubmissionKit={async function (
                            kit_document: any,
                            tag: string
                          ): Promise<boolean> {
                            return await addToSubmissionKit(kit_document, tag);
                          }}
                          submissionKitTags={submissionKitTags}
                          submissionkitDocuments={submissionKitDocuments}
                          sbProfilesMedias={sbProfilesMedias}
                          enableLike={false}
                          profile_status={''}
                          projectId={project.uuid}
                          submissionBoardId={submissionBoardModel.id}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        )}
      </div>
    </>
  );
}
